import { render, staticRenderFns } from "./Factors.vue?vue&type=template&id=7271af9a&scoped=true"
import script from "./Factors.vue?vue&type=script&lang=js"
export * from "./Factors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7271af9a",
  null
  
)

export default component.exports